import { render, staticRenderFns } from "./RiskOverallBanner.vue?vue&type=template&id=a5035ab0&scoped=true"
import script from "./RiskOverallBanner.vue?vue&type=script&lang=js"
export * from "./RiskOverallBanner.vue?vue&type=script&lang=js"
import style0 from "./RiskOverallBanner.vue?vue&type=style&index=0&id=a5035ab0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5035ab0",
  null
  
)

export default component.exports